// Macros during creation, not just on reply (SPEC.md §6). At 89.3% one-touch
// resolution most tickets are created and resolved in the same action, so the
// canned response has to be reachable from this screen or it is reachable too
// late.
//
// Applying a macro is a client-side operation in v1 (docs/API.md §5.1): the body
// template goes into the composer and the actions fold into the create request the
// form was going to send anyway. There is no apply endpoint to call.

// The macro vocabulary and the substitution itself now live in
// ./macro-placeholders.js — a `.js`, so `node --test` can import and walk the list.
// This file is the control and nothing else.

export default function MacroPicker({ macros, onApply, disabled }) {
  if (!macros.length) return null;

  return (
    <div className="flex items-center gap-2">
      <label className="text-xs font-medium text-ink-secondary" htmlFor="macro-picker">
        Apply macro
      </label>
      <select
        id="macro-picker"
        className="field-input max-w-64 py-1 text-sm"
        value=""
        disabled={disabled}
        onChange={(event) => {
          const macro = macros.find((entry) => entry.id === event.target.value);
          if (macro) onApply(macro);
          // Reset so the same macro can be applied twice, and so the control never
          // claims a macro is "on" — applying one is an edit, not a setting.
          event.target.value = '';
        }}
      >
        <option value="">Choose…</option>
        {macros.map((macro) => (
          <option key={macro.id} value={macro.id}>
            {macro.name}
          </option>
        ))}
      </select>
    </div>
  );
}
